import React from "react";

const POSITIONS = {
  "top-left": "top-0 left-0 -translate-x-1/3 -translate-y-1/3",
  "top-right": "top-0 right-0 translate-x-1/3 -translate-y-1/3",
  "bottom-left": "bottom-0 left-0 -translate-x-1/3 translate-y-1/3",
  "bottom-right": "bottom-0 right-0 translate-x-1/3 translate-y-1/3",
};

export default function CornerButton({ position, onClick, disabled, tooltip, children, large = false, className = "" }) {
  const posClass = POSITIONS[position];
  const sizeClass = large ? "w-14 h-14" : "w-10 h-10";
  const baseClass = className || "bg-neutral-800 hover:bg-neutral-700 text-white";
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      className={`absolute ${posClass} ${sizeClass} rounded-full flex items-center justify-center shadow-lg transition-colors disabled:bg-neutral-900 disabled:text-neutral-600 disabled:cursor-not-allowed z-10 ${baseClass}`}
    >
      {children}
    </button>
  );
}
